import * as api from '@/api';

export default {
    data() {
        return {
            vehicle: {
                type: 'truck',
                name: null,
                make: null,
                model: null,
                year: null,
                licensePlate: null,
                vin: null,
                tonsCapacity: null,
                tags: {},
            },

            submitPending: false,
            submitError: null,
        };
    },

    methods: {
        async createVehicle() {
            if (!this.$refs.vehicleForm.validate()) {
                return;
            }

            this.submitPending = true;
            this.submitError = null;

            const company = this.$store.state.company.id;
            const res = await api.createVehicle({ ...this.vehicle, company });

            this.submitPending = false;

            if (res.error) {
                this.submitError = res.error.message;
                this.$awn.alert('Failed to create vehicle');
                return null;
            }

            this.submitError = null;
            this.$awn.success('New vehicle added');

            this.$store.dispatch('company/fetchOverview');

            return res.body;
        },
    },
};
